import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '../../../core/helpers/isMobile';
import GameBoard from '../../../components/common/gameBoard';
import { reelsContainerParams } from '../../../core/constants/reelConstants';

const GameBoardWrapper = observer(() => {
  const { containerConfig } = useMemo(() => {
    return {
      containerConfig: {
        x: reelsContainerParams.xInFigma + reelsContainerParams.width / 2,
        y: reelsContainerParams.yInFigma + reelsContainerParams.height / 2,
      },
    };
  }, []);

  return <GameBoard containerConfig={containerConfig} />;
});

export default GameBoardWrapper;
